import AllPricesTimeSeriesModal from "../../dataTable/modals/AllPricesTimeSeriesModal";
import AllPricesTimeSeriesWithGroupModal from "../../dataTable/modals/AllPricesTimeSeriesWithGroupModal";
import ANOVAModal from "../../dataTable/modals/ANOVAModal";
import CChartModal from "../../dataTable/modals/CChartModal";
import ChiSquareTestModal from "../../dataTable/modals/ChiSquareTestModal";
import CorrelationModal from "../../dataTable/modals/CorrelationModal";
import DescriptiveStatsModal from "../../dataTable/modals/DescriptiveStatsModal";
import GraphicalSummaryModal from "../../dataTable/modals/GraphicalSummaryModal";
import GraphsModal from "../../dataTable/modals/GraphsModal";
import IMRChatModal from "../../dataTable/modals/IMRChartModal";
import LinearRegressionModal from "../../dataTable/modals/LinearRegressionModal";
import MultipleCorrelationModal from "../../dataTable/modals/MultipleCorrelationModal";
import MultipleVariableModal from "../../dataTable/modals/MultipleVariableModal";
import NormalityTestModal from "../../dataTable/modals/NormalityTestModal";
import NPChartModal from "../../dataTable/modals/NPChartModal";
import OneProportionTestModal from "../../dataTable/modals/OneProportionTestModal";
import PairedTTestModal from "../../dataTable/modals/PairedTTestModal";
import ParetoModal from "../../dataTable/modals/ParetoModal";
import PChartModal from "../../dataTable/modals/PChartModal";
import ScatterPlotEDAModal from "../../dataTable/modals/ScatterPlotEDAModal";
import ScatterPlotModal from "../../dataTable/modals/ScatterPlotModal";
import SinglePricesWithGroupTimeSeriesModal from "../../dataTable/modals/SinglePricesWithGroupTimeSeriesModal";
import TimeSeriesModal from "../../dataTable/modals/TimeSeriesModal";
import TTestModal from "../../dataTable/modals/TTestModal";
import TwoSampleTTEstModal from "../../dataTable/modals/TwoSampleTTestModal";
import TwoVarianceTestModal from "../../dataTable/modals/TwoVarianceTestModal";
import UChartModal from "../../dataTable/modals/UChartModal";
import VarianceModal from "../../dataTable/modals/VarianceModal";
import XBarAndR from "../../dataTable/modals/XBarAndRModal";
import XBarAndS from "../../dataTable/modals/XBarAndSModal";

export default function MainModal({ handleClose, openModal, setOpenModal }) {
  return (
    <>
      <DescriptiveStatsModal
        title="Descriptive Statistics"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <GraphicalSummaryModal
        title="Graphical Summary"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <TTestModal
        title="1-Sample t"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <TwoSampleTTEstModal
        title="2-Sample t"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <PairedTTestModal
        title="Paired t"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <OneProportionTestModal
        title="1-Proportion Test"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <NormalityTestModal
        title="Normality Test"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <ChiSquareTestModal
        title="Chi Square Test"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <VarianceModal
        title="1 Variance Test"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <TwoVarianceTestModal
        title="2-Variance Test"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <CorrelationModal
        title="Simple Correlation"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <MultipleCorrelationModal
        title="Multiple Correlation"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <ANOVAModal
        title="ANOVA (One-way)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <TimeSeriesModal
        title="[Single Price] Time Series Plot"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <SinglePricesWithGroupTimeSeriesModal
        title="[Single Price] Time Series Plot with Group"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <AllPricesTimeSeriesModal
        title="[All Prices] Time Series Plot"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <AllPricesTimeSeriesWithGroupModal
        title="[All Prices] Time Series Plot with Group"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <GraphsModal
        title="Simple Box Plot (Group)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <GraphsModal
        title="Simple Box Plot (Ungroup)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <MultipleVariableModal
        title="Multi Variable Boxplot (Group)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <MultipleVariableModal
        title="Multi Variable Boxplot (Ungroup)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <GraphsModal
        title="Simple Histogram"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <GraphsModal
        title="Simple Histogram (with distribution)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <MultipleVariableModal
        title="Multi Variable Histogram"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <MultipleVariableModal
        title="Multi Variable Histogram (with distribution)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <XBarAndS
        title="X-Bar and S"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <XBarAndR
        title="X-Bar and R"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <CChartModal
        title="C-Chart"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <IMRChatModal
        title="I-MR Chart"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <UChartModal
        title="U-Chart"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <NPChartModal
        title="NP-Chart"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <PChartModal
        title="P-Chart"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <ParetoModal
        title="Pareto Chart"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <ScatterPlotModal
        title="Simple Scatterplot"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <MultipleVariableModal
        title="Individual Value Plot"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
        setOpenModals={setOpenModal}
      />
      <LinearRegressionModal
        title="Linear Regression"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <ScatterPlotEDAModal
        title="Scatterplot EDA (Exploratory Data Analysis)"
        closeMenu={handleClose}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </>
  );
}
